<template>
  <div class="dayplanner-sidebar-simple dayplanner-suggestions">

    <template v-if="selected_goal === null">
      <div
        v-for="category in categories"
        v-if="$ready_goals"
        :key="category.$key"
        class="goal-category mb-8 clearfix">

        <inline-goal-list
          :category-name="category.name"
          :category-id="category.$id"
          :value="getUserGoalByCategoryId( category.$id )"
          :list-id="category.$id"
          list-id-param="categoryId"
          add-card-text="New Goal"
          @select="onSelectGoal" />
      </div>
    </template>
    <template v-else>
      <el-button @click="selected_goal = null">
        &larr; Go back
      </el-button>

      <suggestion-drag-list :item-list="myday_suggestions" :clone="cloneItem">
        <component
          class="action-draggable"
          v-for="suggestion_item in myday_suggestions"
          v-bind:is="suggestion_item.componentSuggestion"
          :key="suggestion_item.$key"
          :item-id="suggestion_item.$id"
          :config="suggestion_item.config"
          :name="suggestion_item.title"
          :tsc-color="suggestion_item.config.tscColor"
          @add="onAddSuggestionItem(commitment_suggestion_items.$id, suggestion_item, $event)"
        />
      </suggestion-drag-list>

      <p v-if="myday_suggestions.length === 0">
        No commitments found
        (Create one)
      </p>

    </template>

    <!-- <pre class="mini-pre">{{selected_goal}}</pre> -->
    <!-- <pre class="mini-pre">{{commitments_sorted}}</pre> -->
    <!-- <pre class="mini-pre" v-if="SHOW_DEBUG">{{myday_suggestions}}</pre> -->
    <!-- <pre class="mini-pre" v-if="SHOW_DEBUG">{{user_goal_settings}}</pre> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapReady } from "@/api/misc";
import { make_block } from "../API/util";
import SuggestionDragList from "./SuggestionDragList";
import InlineGoalList from "@/components/Inline/InlineGoalList";
// import util from '@/util'

import ItemTasklist from "./Suggestions/ItemTasklist";
import ItemSequence from "./Suggestions/ItemSequence";
import ItemAmount from "./Suggestions/ItemAmount";
import ItemHabit from "./Suggestions/ItemHabit";

import SidebarMixin from "./SidebarMixin";
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

// TODO: Alle tasks zeigen?
// TODO: Anzahl tasks zeigen?
// TODO: Scroll position merken

export default {
  mixins: [ SidebarMixin, GoalManagementMixin ],
  props: {
  },
  data: () => ({
    selected_goal: null
  }),
  computed: {
    ...mapReady('goals', 'commitments'),
    ...mapGetters("dayplanner", [
      // "dayplan_remaining_timeslots",
      // "dayplan_from_db_at_selected_day",
      // "view_selected_date",
      // "view_selected_date_as_timestamp",
      // "view_selected_date_as_yymmdd",
    ]),

    categories() {
      let categories = this.$models.userGoalCategory.subscribeList().itemsSorted;
      categories.push({ $id: null, $key: 'unassigned', name: 'No category' })
      return categories;
    },

    commitments_sorted() {
      if ( this.selected_goal ) {
        return this.$models.commitmentMeta.with({ goalId: this.selected_goal }).getList().asArraySorted().items;
      }
      return null;
    },

    // timeslot_collection_list() {
    //   return this.$models.timeslotCollection.subscribeList().itemsSorted;
    // },

    myday_suggestions() {
      if (!this.$ready_commitments) {
        return [];
      }

      let items = this.commitments_sorted.map(commitmentMeta => {
        let commitment = this.$models.commitment.with({ goalId: this.selected_goal }).getNodeFull( commitmentMeta.$id )

        // TODO: Show backlog?
        if ( commitment.type === 'BACKLOG' || !commitment.type ) { // TODO !!
          return null
        }

        // TODO: To get tsc colors for sequences:
        // 1. Get commitments via this.$models.commitment.getters.commitment_list_all
        // 2. let tscId = commitment.user.timeslotCollectionId
        // 3: let tsc = timeslot_collection_list[ tscId ]
        // 3. let color = tsc.icon.bgColor

        return {
          $key: commitment.$key,
          $id: commitment.$id,
          $groupId: 1,
          ...make_block(commitment.type, null, null, commitment.meta.name, {
            goalId: this.selected_goal,
            commitmentId: commitment.$id,
            tscId: null,
            tscColor: 'black',
          }),
          componentSuggestion: this.get_component_name( commitment ),
        }
      }).filter(c => c);
      return items;
    },
  },
  methods: {
    onSelectGoal( goalId ) {
      this.selected_goal = goalId;
    }
  },
  components: {
    ItemTasklist,
    ItemSequence,
    ItemAmount,
    ItemHabit,
    InlineGoalList,
    SuggestionDragList,
  }
};
</script>

<style>
</style>
